import React, { Children } from 'react';
import { motion } from 'framer-motion';
const cards = [{
  emoji: '📦',
  title: 'Cadastre suas matérias-primas',
  text: 'Leite condensado, embalagem, fita... tudo com custo unitário calculado automaticamente.'
}, {
  emoji: '💰',
  title: 'Veja o preço certo de cada produto',
  text: 'Com margem de lucro real. O preço aparece enquanto você digita, sem chute nenhum.'
}, {
  emoji: '📋',
  title: 'Organize seus pedidos',
  text: 'Data de entrega, status e lucro de cada encomenda. Nunca mais esquece uma.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 240,
      damping: 22
    }
  }
};
export function NextSteps() {
  return <section className="bg-aurora-warm py-12 md:py-16 px-5" data-id="element-30">
      <div className="max-w-5xl mx-auto" data-id="element-31">
        <h2 className="font-display font-bold text-aurora-dark text-[24px] md:text-[28px] text-center mb-8 md:mb-10" data-id="element-32">
          Por onde começar?
        </h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6" data-id="element-33">
          {cards.map((card, index) => <motion.div key={index} variants={itemVariants} whileHover={{
          y: -4
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 20
        }} className="bg-white rounded-[20px] p-7 shadow-[0_2px_12px_rgba(0,0,0,0.04)] hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)] transition-shadow flex flex-col" data-id="element-34">
              <span className="text-[56px] md:text-[64px] leading-none mb-4 block" data-id="element-35">
                {card.emoji}
              </span>
              <h3 className="font-bold text-aurora-dark text-[17px] mb-2 leading-snug" data-id="element-36">
                {card.title}
              </h3>
              <p className="text-aurora-gray text-[14px] leading-relaxed" data-id="element-37">
                {card.text}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}